import {computed, ref, watch} from '@vue/composition-api'
import store from '@/store'

// Notification
import {useToast} from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useBanksList() {
    // Use toast
    const toast = useToast()

    const refBankListTable = ref(null)

    // Table Handlers
    const tableColumns = [
        {key: 'bank', sortable: true},
        {key: 'description', sortable: true},
        {key: 'status', label: 'Statut', sortable: true},
        {key: 'actions'},
    ]
    const perPage = ref(10)
    const totalBanks = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const dataMeta = computed(() => {
        const localItemsCount = refBankListTable.value ? refBankListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalBanks.value,
        }
    })

    const refetchData = () => {
        refBankListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchBanks = (ctx, callback) => {
        store
            .dispatch('bank/fetchBanks', {
                q: searchQuery.value,
                perPage: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,
            })
            .then(response => {
                const {banks, total} = response

                callback(banks)
                totalBanks.value = total
            })
            .catch((error) => {
                console.log(error)
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Erreur de récupération de la liste des banques',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }

    // *===============================================---*
    // *--------- UI ---------------------------------------*
    // *===============================================---*
    const resolveBankStatusVariant = status => {
        if (status === 'pending') return 'warning'
        if (status === 'active') return 'success'
        if (status === 'inactive') return 'secondary'
        return 'primary'
    }

    return {
        fetchBanks,
        tableColumns,
        perPage,
        currentPage,
        totalBanks,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refBankListTable,

        resolveBankStatusVariant,
        refetchData,
    }
}
